import AccountCardReview from './AccountCardReview';

export default AccountCardReview;
